<template>
    <div class="container rel pad-v-4 pad-h-2 mrg-v-2 mrg-v-0-s pad-h-1-s">
        <!--遮罩-->
        <matteWidget v-bind="matteData" />

        <h3 class="rel mrg-b-1">
            <span class="fsize-1d5 fsize-1-s">获取数据包</span>
        </h3>
        <article class="rel container fsize-1d2" md>
            <p class="fsize-1d2">清华 DaaS 数据库下载地址</p>
            <p>
                <a href="http://daas.2861.wiki" class="color-yellow fsize-1d5">http://daas.2861.wiki</a>
            </p>
            <p class="alpha-d6">
                14 天免费试用<br>
                需要服务支持请联系： daas@tsinghua.edu.cn
            </p>
        </article>
    </div>
</template>

<script>
    import matteWidget from "@/components/matte-widget"

    export default {
        name: "sec-data-package-widget",
        components: {
            matteWidget
        },
        props: ["matteData"]
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-data-package-widget.vue